var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loading",class:{
    'size-default': _vm.size === 'default',
    'size-big': _vm.size === 'big',
  }},[(_vm.loading && !_vm.refreshFlag)?_c('LoadingSVG',{style:({ 'top': _vm.pos })}):_vm._e(),(_vm.loading && _vm.refreshFlag)?_c('app-btn',{on:{"click":function($event){return _vm.refresh()}}},[_vm._v(" Refresh ")]):_vm._e(),(!_vm.loading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }